import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const ProjectVersionHistoryContext = createContext();

export const ProjectVersionHistoryProvider = ({ children }) => {
  const [showVersionHistoryBar, setShowVersionHistoryBar] = useState(false);
  const [readOnlyMode, setReadOnlyMode] = useState(false);
  const [selectedListItem, setSelectedListItem] = useState(null);
  const [isCurrentVersion, setIsCurrentVersion] = useState(false);
  const [undoEdits, setUndoEdits] = useState(false);
  const [redoEdits, setRedoEdits] = useState(false);
  const [undo, setUndo] = useState(false);
  const [redo, setRedo] = useState(false);

  const values = useMemo(() => ({
    showVersionHistoryBar,
    setShowVersionHistoryBar,
    readOnlyMode,
    setReadOnlyMode,
    selectedListItem,
    setSelectedListItem,
    isCurrentVersion,
    setIsCurrentVersion,
    undo,
    setUndo,
    undoEdits,
    setUndoEdits,
    redo,
    setRedo,
    redoEdits,
    setRedoEdits,
  }), [
    showVersionHistoryBar,
    readOnlyMode,
    selectedListItem,
    isCurrentVersion,
    undo,
    redo,
    undoEdits,
    redoEdits,
  ]);

  return <ProjectVersionHistoryContext.Provider value={values}>{children}</ProjectVersionHistoryContext.Provider>;
};

const useProjectVersionHistory = () => {
  const context = useContext(ProjectVersionHistoryContext);
  if (context === undefined) {
    throw new Error('useProjectVersionHistory must be used within a ProjectVersionHistoryProvider');
  }
  return context;
};

ProjectVersionHistoryProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default useProjectVersionHistory;
